/**
* ----------------------------------------------------------------------------
* Richtext read more
* ----------------------------------------------------------------------------
*/

document.addEventListener('DOMContentLoaded', function() {
  const readMoreContainers = document.querySelectorAll('.richtext__read-more--container');

  for(const readMoreContainer of readMoreContainers) {
    const readMoreButton = readMoreContainer.querySelector('.richtext__read-more--button');
    const readLessButton = readMoreContainer.querySelector('.richtext__read-less--button');
    const readMoreContent = readMoreContainer.querySelector('.richtext__read-more--content');
    const readMoreInner = readMoreContainer.querySelector('.richtext__read-more--inner');

    readMoreButton.addEventListener('click', function() {
      readMoreContent.style.setProperty('--inner-height', readMoreInner.getBoundingClientRect().height + "px");
      readMoreContainer.classList.add('open');
    });

    readLessButton.addEventListener('click', function() {
      readMoreContainer.classList.remove('open');
    });
  }
});

/**
* ----------------------------------------------------------------------------
* Blog Posts
* ----------------------------------------------------------------------------
*/

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.blog-posts--section');

  for(const section of sections) {
    const tagButtons = section.querySelectorAll('.blog-post--tag');

    if(tagButtons.length > 0) {
      const blogPosts = section.querySelectorAll('.blog-post-card');

      for(const tagButton of tagButtons) {
        tagButton.addEventListener('click', function() {
          if(tagButton.dataset.function == "all") {
            /* All */
            for(const blogPost of blogPosts) {
              blogPost.classList.remove('hidden');
            }
          } 
          else {
            /* Specific */
            for(const blogPost of blogPosts) {
              if(blogPost.dataset.tags) {
                const tags = blogPost.dataset.tags.split(',');
                if(!(tags.includes(tagButton.dataset.function))) {
                  blogPost.classList.add('hidden');
                }
                else {
                  blogPost.classList.remove('hidden');
                }
              }
            }
          }

          section.querySelector('.blog-post--tag.is-selected').classList.remove('is-selected');
          tagButton.classList.add('is-selected');
        });
      }
    }
  }
});